import { JobDetailsType } from "../JobDetails"
import { ReactComponent as PlayIcon } from '../../../../assets/Icons/adornments/Play-Solid.svg';
import { useEffect, useState } from "react";
import { capitalize } from "../../../../utils/formattingFns";
import { statusColors } from "../GanttChart";

export default function DetailsPanel({
    details,
}: {
    details: JobDetailsType,
}) {
    const [ formattedDetails, setFormattedDetails ] = useState<{[key: string]: string | number} | null>(null);

    function formatMilliseconds(ms: number) {
        const totalSeconds = Math.floor(ms / 1000);
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
      
        return `${hours}:${minutes}:${seconds}`;
      }

    useEffect(() => {
        let jobDetails: any = {
            status: details.state,            
        };

        if (details.task_id) {
            jobDetails['task_id'] = details.task_id
        } 

        jobDetails = {
            ...jobDetails,
            run_id: details.run_id
        }

        if (details.run_type) {
            jobDetails['run_type'] = details.run_type
        }

        if (details.map_index) {
            jobDetails['map_index'] = details.map_index
        }

        if (details.mapped_task_instances) {
            jobDetails['mapped_task_instances'] = details.mapped_task_instances
        }

        jobDetails = {
            ...jobDetails,
            duration: formatMilliseconds(details.duration),
        }

        if (details.queued_at) {
            jobDetails['queued_at'] = details.queued_at
        }

        jobDetails = {
            ...jobDetails,
            start_date: details.start_date,
            end_date: details.end_date,
        }

        if (details.externally_triggered !== undefined) {
            jobDetails['externally_triggered'] = details.externally_triggered ? 'True' : 'False'
        }

        if (details.try_number) {
            jobDetails['try_number'] = details.try_number
        }

        if (details.max_tries) {
            jobDetails['max_tries'] = details.max_tries
        }

        setFormattedDetails(jobDetails);

    }, [details]);

    return (
        <div className="w-full overflow-y-auto h-fit">
            <div className="job-details-grid w-full rounded-lg font-medium overflow-hidden">
                {formattedDetails && Object.keys(formattedDetails).map(key => {
                    const value = formattedDetails[key];
                    const label = key.split('_').map(word => capitalize(word)).join(' ');

                    return (
                        <>
                            <div className="cell">
                                <p className="text-quaternary text-[12px] font-semibold">{label}</p>
                            </div>

                            <div className={`cell ${(key === 'run_type' || key === 'status') && 'flex justify-start items-center gap-3'}`}>
                                {key === 'status' && (
                                    <div style={{ backgroundColor: statusColors[value as keyof object] }} className={`w-[12px] aspect-square rounded-sm`}></div>
                                )}
                                {key === 'run_type' && (
                                    <div className="w-[12px] text-default"><PlayIcon/></div>
                                )}
                                <p className="text-default text-[12px] font-medium">{value}</p>
                            </div>
                        </>
                    )
                })}
            </div>
        </div>
    )
}